import { Injectable, isDevMode } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { ReportType } from '@app/domain/model/report-type';
import { catchError } from 'rxjs/operators';
import { PaperReportModel } from './paper-report.model';
import { HttpClient } from '@angular/common/http';
import { DateFormatter } from '@app/util/date-formatter';

@Injectable({
  providedIn: 'root'
})
export class PaperReportService {

  constructor(private http: HttpClient) { }

  addPaperReport(report: PaperReportModel): Observable<any> {

    // Convert the purchase report into JSON representation, ...
    const requestBody = JSON.stringify(
      Object.assign({}, {
        dealerId: report.dealerId,
        reportType: ReportType[report.reportType],
        month: report.month + 1,
        year: report.year,
        dateReceived: DateFormatter.formatDateBeforeSend(report.dateReceived),
        paperPurchaseReportItems: report.paperPurchaseReportItems
      }));

    // ... and send it to the back-end.
    return this.http
      .post('paper/reports/add', requestBody, {headers: {'Content-Type': 'application/json'}})
      .pipe(catchError(this.handleError));
  }

  validatePaperReport(report: PaperReportModel): Observable<any> {

    // Convert the purchase report into JSON representation, ...
    const requestBody = JSON.stringify(
      Object.assign({}, {
        dealerId: report.dealerId,
        reportType: ReportType[report.reportType],
        month: report.month + 1,
        year: report.year,
        dateReceived: DateFormatter.formatDateBeforeSend(report.dateReceived),
        paperPurchaseReportItems: report.paperPurchaseReportItems
      }));

    // ... and send it to the back-end.
    return this.http
      .post('paper/reports/validate', requestBody, {headers: {'Content-Type': 'application/json'}})
      .pipe(catchError(this.handleError));
  }

  private handleError(error: Error) {
    if (isDevMode()) {
      console.error('Add paper report problem: ', error);
    }

    return throwError(error);
  }

}
